import { gql } from '@apollo/client';

export const UPDATE_USER_ADDITIONAL_DATA_MUTATION = gql`
  mutation updateUserAdditionalData($input: UserAdditionalDataInput!) {
    updateUserAdditionalData(input: $input) {
      correlationId
    }
  }
`;

export const SAVE_USER_AGENDA = gql`
  mutation updateUserAgendaData($userId: Int!, $input: [UserAgendaDataInput]!) {
    updateUserAgendaData(userId: $userId, input: $input) {
      correlationId
    }
  }
`;
